export const COUNTRIES = [
  {
    id: 'BE',
    value: 'Belgium',
  },
  {
    id: 'DE',
    value: 'Germany',
  },
  {
    id: 'HU',
    value: 'Hungary',
  },
  {
    id: 'NL',
    value: 'Netherlands',
  },
  {
    id: 'PL',
    value: 'Poland',
  },
  {
    id: 'JO',
    value: 'Jordan',
  },
  {
    id: 'NG',
    value: 'Nigeria',
  },
  {
    id: 'JM',
    value: 'Jamaica',
  },
  {
    id: 'TZ',
    value: 'Tanzania',
  },
];
